import { css } from '@compiled/react'
import useAuth from '@hooks/useAuth'

export const Vote = ({ review, onVote }) => {
  const { user } = useAuth()

  return (
    <div
      className={`cursor-pointer ${review.upvoted && 'text-orange'}`}
      css={css`
        cursor: ${user ? 'pointer' : 'not-allowed'};
        color: ${!user ? '#b5b5b5' : review.upvoted ? '#f93' : '#000'};
      `}
      onClick={user ? onVote : null}
    >
      <i className="fa fa-thumbs-up tw-mr-1" />
      {review.upvotesCount}
    </div>
  )
}
